import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AclService {

  permissions: BehaviorSubject<any> = new BehaviorSubject({ fetched: false, resources: [] });
  constructor() { }
}
